import { Deck, DeckCard, DeckCardTagType } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupOathbreaker extends DeckGroup {
    public constructor() {
        super("Oathbreaker", `${environment.ponderImageBaseUrl}/magic/set/ddr.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        return (card.tag == DeckCardTagType.Oathbreaker);
    }
}